let viewer;
const loadViewer = () =>
  (viewer ||= import(globalThis.MeriAssets?.quickMedia || './quick-media-viewer.js').catch((error) => {
    viewer = null;
    throw error;
  }));
// The dialog stylesheet is not render-blocking in the head. Start fetching it on
// the first intent, in parallel with the viewer module, so the first open does not
// wait for two sequential downloads. openQuickMedia() still waits for it.
const warmStyles = () => {
  const href = globalThis.MeriAssets?.quickMediaStyles;
  if (!href) return;
  const absolute = new URL(href, location.href).href;
  if ([...document.querySelectorAll('link[rel="stylesheet"]')].some((link) => link.href === absolute)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = absolute;
  // A failed early request is removed so the viewer can retry with a fresh link.
  link.addEventListener('error', () => link.remove(), { once: true });
  document.head.append(link);
};
// 2.9.9 (Owner): a pointer or keyboard focus resting on the eye for a moment, or a finger on it, also fetches the
// product's quick view media and first picture, so the click shows them at once. Passing over the eye fetches nothing.
let resting;
const prefetch = (trigger) =>
  loadViewer()
    .then((module) => module.prefetchQuickMedia?.(trigger))
    .catch(() => {});
const prepare = (event) => {
  const trigger = event.target.closest('a[data-quick-media]');
  if (!trigger) return;
  warmStyles();
  loadViewer()
    .then((module) => module.prepareQuickMedia())
    .catch(() => {});
  clearTimeout(resting);
  if (event.type === 'focusin' || (event.type === 'pointerover' && event.pointerType !== 'touch'))
    resting = setTimeout(() => prefetch(trigger), 100);
  else prefetch(trigger);
};
const leave = (event) => {
  const trigger = event.target.closest?.('a[data-quick-media]');
  if (trigger && !trigger.contains(event.relatedTarget)) clearTimeout(resting);
};
document.addEventListener('pointerover', prepare, { passive: true });
document.addEventListener('focusin', prepare);
document.addEventListener('pointerout', leave, { passive: true });
document.addEventListener('focusout', leave);
document.addEventListener('touchstart', prepare, { passive: true });
document.addEventListener(
  'pointerdown',
  (event) => {
    event.target.closest('a[data-quick-media]')?.setAttribute('data-quick-media-pointer', '');
    prepare(event);
  },
  { passive: true },
);
document.addEventListener('keydown', (event) => {
  if (event.key === 'Tab')
    document
      .querySelectorAll('[data-quick-media-pointer]')
      .forEach((el) => el.removeAttribute('data-quick-media-pointer'));
});
document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('a[data-quick-media]');
  if (!trigger || event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  if (!globalThis.HTMLDialogElement?.prototype.showModal) return;
  event.preventDefault();
  if (trigger.getAttribute('aria-busy') === 'true') return;
  trigger.setAttribute('aria-busy', 'true');
  try {
    const { openQuickMedia } = await loadViewer();
    await openQuickMedia(trigger, { keyboard: event.detail === 0 });
  } catch {
    location.assign(trigger.href);
  } finally {
    trigger.removeAttribute('aria-busy');
  }
});
